/**
 * This file contains all state-changing actions relevant for the main application.
 */

export const CLEAR_NOTIFICATION = 'APPLICATION/CLEAR_NOTIFICATION';
export const clearNotification = () => ({
  type: CLEAR_NOTIFICATION,
  payload: {},
});

export const CREATE_NOTIFICATION = 'APPLICATION/CREATE_NOTIFICATION';
export const createNotification = (title: any, message: any) => ({
  type: CREATE_NOTIFICATION,
  payload: { title, message },
});

export const SET_CONNECTED = 'APPLICATION/SET_CONNECTED';
export const setConnected = (connected: boolean) => ({
  type: SET_CONNECTED,
  payload: { connected },
});

export const SET_DRAFT = 'APPLICATION/SET_DRAFT';
export const setDraft = (draft: boolean) => ({
  type: SET_DRAFT,
  payload: { draft },
});

export const SET_CONNECTION_MODAL_OPEN = 'APPLICATION/SET_CONNECTION_MODAL_OPEN';
export const setConnectionModalOpen = (open: boolean) => ({
  type: SET_CONNECTION_MODAL_OPEN,
  payload: { open },
});

export const SET_ABOUT_MODAL_OPEN = 'APPLICATION/SET_ABOUT_MODAL_OPEN';
export const setAboutModalOpen = (open: boolean) => ({
  type: SET_ABOUT_MODAL_OPEN,
  payload: { open },
});

export const SET_REPORT_HELP_MODAL_OPEN = 'APPLICATION/SET_REPORT_HELP_MODAL_OPEN';
export const setReportHelpModalOpen = (open: boolean) => ({
  type: SET_REPORT_HELP_MODAL_OPEN,
  payload: { open },
});

export const SET_WELCOME_SCREEN_OPEN = 'APPLICATION/SET_WELCOME_SCREEN_OPEN';
export const setWelcomeScreenOpen = (open: boolean) => ({
  type: SET_WELCOME_SCREEN_OPEN,
  payload: { open },
});
export const SET_CONNECTION_PROPERTIES = 'APPLICATION/SET_CONNECTION_PROPERTIES';
export const setConnectionProperties = (
  protocol: string,
  url: string,
  port: string,
  database: string,
  username: string,
  password: string
) => ({
  type: SET_CONNECTION_PROPERTIES,
  payload: { protocol, url, port, database, username, password },
});

export const SET_BASIC_CONNECTION_PROPERTIES = 'APPLICATION/SET_BASIC_CONNECTION_PROPERTIES';
export const setBasicConnectionProperties = (
  protocol: string,
  url: string,
  port: string,
  database: string,
  username: string,
  password: string
) => ({
  type: SET_CONNECTION_PROPERTIES,
  payload: { protocol, url, port, database, username, password },
});

export const SET_DESKTOP_CONNECTION_PROPERTIES = 'APPLICATION/SET_DESKTOP_CONNECTION_PROPERTIES';
export const setDesktopConnectionProperties = (
  protocol: string,
  url: string,
  port: string,
  database: string,
  username: string,
  password: string
) => ({
  type: SET_DESKTOP_CONNECTION_PROPERTIES,
  payload: { protocol, url, port, database, username, password },
});

export const CLEAR_DESKTOP_CONNECTION_PROPERTIES = 'APPLICATION/CLEAR_DESKTOP_CONNECTION_PROPERTIES';
export const clearDesktopConnectionProperties = () => ({
  type: CLEAR_DESKTOP_CONNECTION_PROPERTIES,
  payload: {},
});

// Legacy pre1-v2 dashboard that can be optionally upgraded.
export const SET_OLD_DASHBOARD = 'APPLICATION/SET_OLD_DASHBOARD';
export const setOldDashboard = (text: string) => ({
  type: SET_OLD_DASHBOARD,
  payload: { text },
});

// Legacy pre1-v2 dashboard that can be optionally upgraded.
export const RESET_SHARE_DETAILS = 'APPLICATION/RESET_SHARE_DETAILS';
export const resetShareDetails = () => ({
  type: RESET_SHARE_DETAILS,
  payload: {},
});

export const SET_SHARE_DETAILS_FROM_URL = 'APPLICATION/SET_SHARE_DETAILS_FROM_URL';
export const setShareDetailsFromUrl = (
  type: string,
  id: string,
  standalone: boolean,
  protocol: string,
  url: string,
  port: string,
  database: string,
  username: string,
  password: string,
  dashboardDatabase: string,
  skipConfirmation: boolean
) => ({
  type: SET_SHARE_DETAILS_FROM_URL,
  payload: {
    type,
    id,
    standalone,
    protocol,
    url,
    port,
    database,
    username,
    password,
    dashboardDatabase,
    skipConfirmation,
  },
});

export const SET_STANDALONE_ENABLED = 'APPLICATION/SET_STANDALONE_ENABLED';
export const setStandaloneEnabled = (
  standalone: boolean,
  standaloneProtocol: string,
  standaloneHost: string,
  standalonePort: string,
  standaloneDatabase: string,
  standaloneDashboardName: string,
  standaloneDashboardDatabase: string,
  standaloneDashboardURL: string,
  standaloneUsername: string,
  standalonePassword: string,
  standalonePasswordWarningHidden: boolean,
  standaloneAllowLoad: boolean,
  standaloneLoadFromOtherDatabases: boolean,
  standaloneMultiDatabase: boolean,
  standaloneDatabaseList: string
) => ({
  type: SET_STANDALONE_ENABLED,
  payload: {
    standalone,
    standaloneProtocol,
    standaloneHost,
    standalonePort,
    standaloneDatabase,
    standaloneDashboardName,
    standaloneDashboardDatabase,
    standaloneDashboardURL,
    standaloneUsername,
    standalonePassword,
    standalonePasswordWarningHidden,
    standaloneAllowLoad,
    standaloneLoadFromOtherDatabases,
    standaloneMultiDatabase,
    standaloneDatabaseList,
  },
});

export const SET_STANDALONE_MODE = 'APPLICATION/SET_STANDALONE_MODE';
export const setStandaloneMode = (standalone: boolean) => ({
  type: SET_STANDALONE_MODE,
  payload: { standalone },
});

export const SET_STANDALONE_DASHBOARD_DATEBASE = 'APPLICATION/SET_STANDALONE_DASHBOARD_DATEBASE';
export const setStandaloneDashboardDatabase = (dashboardDatabase: string) => ({
  type: SET_STANDALONE_DASHBOARD_DATEBASE,
  payload: { dashboardDatabase },
});

export const SET_SSO_ENABLED = 'APPLICATION/SET_SSO_ENABLED';
export const setSSOEnabled = (enabled: boolean, discoveryUrl: string) => ({
  type: SET_SSO_ENABLED,
  payload: { enabled, discoveryUrl },
});

export const SET_SSO_PROVIDERS = 'APPLICATION/SET_SSO_PROVIDERS';
export const setSSOProviders = (providers: []) => ({
  type: SET_SSO_PROVIDERS,
  payload: { providers },
});

export const SET_WAIT_FOR_SSO = 'APPLICATION/SET_WAIT_FOR_SSO';
export const setWaitForSSO = (wait: boolean) => ({
  type: SET_WAIT_FOR_SSO,
  payload: { wait },
});

export const SET_CACHED_SSO_DISCOVERY_URL = 'APPLICATION/SET_CACHED_SSO_DISCOVERY_URL';
export const setCachedSSODiscoveryUrl = (url: string) => ({
  type: SET_CACHED_SSO_DISCOVERY_URL,
  payload: { url },
});

export const SET_SESSION_PARAMETERS = 'APPLICATION/SET_SESSION_PARAMETERS';
export const setSessionParameters = (parameters: any) => ({
  type: SET_SESSION_PARAMETERS,
  payload: { parameters },
});

export const SET_DASHBOARD_TO_LOAD_AFTER_CONNECTING = 'APPLICATION/SET_DASHBOARD_TO_LOAD_AFTER_CONNECTING';
export const setDashboardToLoadAfterConnecting = (id: any) => ({
  type: SET_DASHBOARD_TO_LOAD_AFTER_CONNECTING,
  payload: { id },
});

export const SET_PARAMETERS_TO_LOAD_AFTER_CONNECTING = 'APPLICATION/SET_PARAMETERS_TO_LOAD_AFTER_CONNECTING';
export const setParametersToLoadAfterConnecting = (parameters: any) => ({
  type: SET_PARAMETERS_TO_LOAD_AFTER_CONNECTING,
  payload: { parameters },
});

export const SET_CUSTOM_HEADER = 'APPLICATION/SET_CUSTOM_HEADER';
export const setCustomHeader = (customHeader: any) => ({
  type: SET_CUSTOM_HEADER,
  payload: { customHeader },
});

export const SET_DEV_MODE = 'APPLICATION/SET_DEV_MODE';
export const setDevMode = (devMode: boolean) => ({
  type: SET_DEV_MODE,
  payload: { devMode },
});

export const SET_DEPRECATION_NOTICE = 'APPLICATION/SET_DEPRECATION_NOTICE';
export const setDeprecationNotice = (deprecated: boolean) => ({
  type: SET_DEPRECATION_NOTICE,
  payload: { deprecated },
});

export const SET_AUTH_ENABLED = 'APPLICATION/SET_AUTH_ENABLED';
export const setAuthEnabled = (enabled: boolean, allowedDomains: string[]) => ({
  type: SET_AUTH_ENABLED,
  payload: { enabled, allowedDomains },
});

export const SET_AUTH_USER_EMAIL = 'APPLICATION/SET_AUTH_USER_EMAIL';
export const setAuthUserEmail = (email: string | null) => ({
  type: SET_AUTH_USER_EMAIL,
  payload: { email },
});

export const SET_AUTH_LOGIN_ERROR = 'APPLICATION/SET_AUTH_LOGIN_ERROR';
export const setAuthLoginError = (error: string) => ({
  type: SET_AUTH_LOGIN_ERROR,
  payload: { error },
});

export const SET_AUTH_LOGIN_LOADING = 'APPLICATION/SET_AUTH_LOGIN_LOADING';
export const setAuthLoginLoading = (loading: boolean) => ({
  type: SET_AUTH_LOGIN_LOADING,
  payload: { loading },
});

export const SET_PENDING_CONFIG = 'APPLICATION/SET_PENDING_CONFIG';
export const setPendingConfig = (config: any, params: any, standalone: boolean) => ({
  type: SET_PENDING_CONFIG,
  payload: { config, params, standalone },
});
